/**
 * PROPRIETARY AND CONFIDENTIAL
 * Copyright © 2026 Contractor Co-Pilot. All Rights Reserved.
 */

"use client";

import { SolutionTemplate } from "@/components/landing/solution-template";
import { concreteConfig } from "./concrete-config";

export function ConcreteSolutionsPageClient() {
  return <SolutionTemplate config={concreteConfig} />;
}
